export interface EditorLinkTarget {
  blockId: string
  text?: string
  /** Zero-based UTF-16 offset in the block's visible text. */
  offset?: number
}

/** A quote always belongs to a block, which remains the fallback when the text changes. */
export function readEditorLinkTarget(location: { hash: string; search: string }): EditorLinkTarget | null {
  if (!location.hash || location.hash === '#') {
    return null
  }

  let blockId: string
  try {
    blockId = decodeURIComponent(location.hash.slice(1))
  } catch {
    return null
  }

  const params = new URLSearchParams(location.search)
  const text = params.get('text')
  if (!text?.trim()) {
    return { blockId }
  }

  const rawOffset = params.get('offset')
  const offset = rawOffset !== null && /^\d+$/.test(rawOffset) ? Number(rawOffset) : undefined
  return {
    blockId,
    text,
    offset: offset !== undefined && Number.isSafeInteger(offset) ? offset : undefined,
  }
}

export function buildEditorPassagePath(bookId: string, filename: string, target: EditorLinkTarget): string {
  const params = new URLSearchParams()
  if (target.text?.trim()) {
    params.set('text', target.text)
    if (target.offset !== undefined && Number.isSafeInteger(target.offset) && target.offset >= 0) {
      params.set('offset', String(target.offset))
    }
  }
  const query = params.size ? `?${params.toString()}` : ''
  return `/edit/${bookId}/${encodeURIComponent(filename)}${query}#${encodeURIComponent(target.blockId)}`
}
